import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import './Statistics.css';

const Statistics = () => {
  const [ref, isVisible] = useIntersectionObserver();
  const [counts, setCounts] = useState({ projects: 0, clients: 0, years: 0, team: 0 });

  const stats = [
    { label: 'Projects Completed', value: 500, key: 'projects' },
    { label: 'Happy Clients', value: 350, key: 'clients' },
    { label: 'Years Experience', value: 15, key: 'years' },
    { label: 'Team Members', value: 50, key: 'team' }
  ];

  useEffect(() => {
    if (isVisible) {
      stats.forEach(stat => {
        let start = 0;
        const end = stat.value;
        const duration = 2000;
        const increment = end / (duration / 16);

        const timer = setInterval(() => {
          start += increment;
          if (start >= end) {
            setCounts(prev => ({ ...prev, [stat.key]: end }));
            clearInterval(timer);
          } else {
            setCounts(prev => ({ ...prev, [stat.key]: Math.floor(start) }));
          }
        }, 16);
      });
    }
  }, [isVisible]);

  return (
    <section className="statistics-section section" ref={ref}>
      <div className="container">
        <div className="statistics-grid">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              className="stat-card"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={isVisible ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <h2>{counts[stat.key]}+</h2>
              <p>{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Statistics;
